import React from 'react'
import styled, { css } from 'styled-components'
import { colors } from '../../styles'

interface IImage extends React.HTMLAttributes<HTMLImageElement> {
  bordered?: boolean
  fullWidth?: boolean
}

export const Image = styled.img<IImage>`
  max-width: 100%;
  ${({ bordered }) =>
    !!bordered &&
    css`
      border: 1px solid ${colors.grey10};
    `}
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
  max-width: 100%;
`
